const config = require('../config.js');
const coins = require(`./coins-${config.blockchainId}.js`);
const { arrayToHashmap, uniqBy, flattenArray } = require('../../utils/Array');
const REFERENCE_ASSETS = require('../reference-assets.js');

const FIAT_ASSET_TYPES = [
    REFERENCE_ASSETS.USD,
    REFERENCE_ASSETS.EUR,
];

const defaultCoinTemplate = {
    id: undefined,
    type: undefined,
    symbol: undefined,
    decimals: undefined,
    address: undefined,
    isSynth: false,
    isLpToken: false,
    wrappedCoinType: null,
    isTradable: true, // Whether this coin is offered for trade in OneSplit
};

const augmentedCoins = arrayToHashmap(Array.from(Object.entries(coins)).map(([id, coin]) => [id, {
    ...defaultCoinTemplate,
    ...coin,
    get isWrappedCoin() {
        return this.wrappedCoinType !== null;
    },
    get isFiat() {
        return FIAT_ASSET_TYPES.includes(this.type);
    },
    get getCoingeckoId() {
        return this.coingeckoId || this.id;
    },
}]));

let factoryV2PoolCoins;
if (process.env.CLI_SCRIPT !== 'build-icons') {
    setTimeout(async () => {
        const { default: getFactoryV2Pools } = require('../../utils/data/getFactoryV2Pools');
        const { default: getFactoryCryptoPools } = require('../../utils/data/getFactoryCryptoPools');

        const [factoryV2PoolsData, factoryCryptoPoolsData] = await Promise.all([
            getFactoryV2Pools(),
            getFactoryCryptoPools(),
        ]);

        factoryV2PoolCoins = arrayToHashmap(
            flattenArray(
                uniqBy(flattenArray([...factoryV2PoolsData, ...factoryCryptoPoolsData].map(({ coins }) => coins)), 'address')
                    .map((coin) => [
                        [coin.symbol.toLowerCase(), coin],
                        [coin.address.toLowerCase(), coin],
                    ])
            )
        );
    });
}

// Precedence: coins config file, then onchain data for facto pools coins.
// Facto pools coins are indexed both by symbol and address.
const coinsProxy = new Proxy(augmentedCoins, {
    get: function(target, name) {
        if (factoryV2PoolCoins && factoryV2PoolCoins[name] && !target[name]) return factoryV2PoolCoins[name];

        if (
            typeof name === 'string' &&
            !(name in target) &&
            name !== 'inspect' &&
            name !== 'state' &&
            name !== 'render' &&
            !name.startsWith('_') // Ignore "private" props
        ) {
            throw new Error(`Property "${name}" not found on object "coins"`);
        }

        return target[name];
    },
});

module.exports = coinsProxy;
